// import { clearDataAction, logoutAction } from './reducers';
import api from '../../api';
import { AuthService } from '../api';
import { unauthorizedApiResponseInterceptor } from '../api/interceptor';
import { UserType } from '../api/models';

const initialize = (store: any, setToken: (token?: string) => void) => {
  const state = store.getState();
  unauthorizedApiResponseInterceptor(async () => {
    // store.dispatch(logoutAction);
    // store.dispatch(clearDataAction());

    // Get current tokens before clearing them
    const currentUserToken = api.getUserToken();
    const currentSalesPersonToken = api.getSalespersonToken();

    // Now you have access to both tokens
    console.log('Current User Token:', currentUserToken);
    const response = await api.auth.logout(currentUserToken || '');
    api.setUserToken(undefined);
    api.setSalespersonToken(undefined);
    api.setUserType(undefined);
    api.setUserStatus(undefined);
    // window.location.reload();
  }, [AuthService.loginUrl]);

  // setToken(state.authUser.token);
  api.setBrandID(state.brandAndBranch?.selectedBrand?.brandID);
  api.setBranchID(state.brandAndBranch?.selectedBranch?.warehouseID);
  if (state.authUser.userToken) {
    api.setUserToken(state.authUser.userToken);
    // store.dispatch(userActions.fetchProfile());
  }
  if (state.authUser.salesPersonToken) {
    api.setSalespersonToken(state.authUser.salesPersonToken);
  }
  if (state.authUser.userType) {
    api.setUserType(state.authUser.userType);
  }
  if (state.authUser.userStatus) {
    api.setUserStatus(state.authUser.userStatus);
  }
};

export default initialize;
